// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3mUEY","tab":"Tabs_tab__bNB0m","tabActive":"Tabs_tabActive__1DMOS"};